import { AddressOption, houseAddressKeys } from './HouseAddress';

type defaultAddressesProperties = Record<houseAddressKeys, AddressOption>;
export function getDefaultAddresses(addresses: houseAddressKeys): AddressOption;
export function getDefaultAddresses(): defaultAddressesProperties;
export function getDefaultAddresses(addresses?: houseAddressKeys) {
    return addresses ? defaultAddresses[addresses] : defaultAddresses;
}

const defaultAddresses: defaultAddressesProperties = {
    showPolicyAddresses: {
        valueOnSubmit: {
            buttonType: 'HOME',
            label: '',
            policies: []
        },
        label: '',
        value: 'showPolicyAddresses'
    },
    showInMyVehicle: {
        valueOnSubmit: {
            buttonType: 'CAMPING',
            label: 'I mit køretøj'
        },
        label: 'I mit køretøj',
        value: 'showInMyVehicle'
    },
    showInAHotelOrOtherCottage: {
        valueOnSubmit: {
            buttonType: 'HOTEL',
            label: 'På et hotel eller i en anden feriebolig'
        },
        label: 'På et hotel eller i en anden feriebolig',
        value: 'showInAHotelOrOtherCottage'
    },
    showOtherAddressDanish: {
        valueOnSubmit: {
            buttonType: 'OTHER',
            label: 'En dansk adresse',
            description: ''
        },
        label: 'En dansk adresse',
        value: 'showOtherAddressDanish'
    },
    showOtherAddressForeign: {
        valueOnSubmit: {
            buttonType: 'OTHER',
            label: 'En udenlandsk adresse',
            description: ''
        },
        label: 'En udenlandsk adresse',
        value: 'showOtherAddressForeign'
    },
    showOtherPlace: {
        valueOnSubmit: {
            buttonType: 'OTHER',
            label: 'Et andet sted',
            description: ''
        },
        label: 'Et andet sted',
        value: 'showOtherPlace'
    }
};
